export const Button = 1
export const Col = 2
export const ColGroup = 3
export const Div = 4
export const H1 = 5
export const Input = 6
export const Kbd = 7
export const Span = 8
export const Table = 9
export const TBody = 10
export const Td = 11
export const Text = 12
export const Th = 13
export const THead = 14
export const Tr = 15
export const I = 16
export const Img = 17
export const Root = 0
export const Ins = 20
export const Del = 21
